import React, { useContext, useState } from 'react';

import PropTypes from 'prop-types';

import { Form, FormControl } from 'react-bootstrap';
import Axios from 'axios';
import DashboardContext from '../../Context';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

/**
 * اینپوت شماره موبایل است<br>
 * این کامپوننت عتبار سنجی شماره موبایل رو انجام می دهد<br>
 */
export default function Mobilecheckexist({
  label,
  name,
  defaultValue,
  handelValue,
  Placeholder,
  autoComplete,
  handelstatusemobile,
  ismodal,
  handelmobileNumber,
  disabled,
  isSmsLog,
  onChangeFunction,
}) {
  const { authentication, urldashboard, handelEdit, handelAdd } =
    useContext(DashboardContext);

  const [error, setError] = useState('');

  const [colorerror, setColorerror] = useState('');

  const [statuseMobile, setStatuseMobile] = useState(false);

  const [userIDFind, setUserIDFind] = useState('');

  const pattern = new RegExp(/^(0|0098|\+98)9\d{9}$/);

  const hedelonCheng = (event) => {
    if (event.target.value) {
      const vlaue = event.target.value;
      if (pattern.test(vlaue)) {
        if (vlaue.length < 10) {
          onChangeFunction();
        } else {
          checkeMobilenumber(vlaue);
          setError('شماره موبایل قابل ثبت است');
          setColorerror('green');
          handelValue(name, vlaue);
        }
      } else {
        if (new RegExp(/^[0-9]+$/).test(vlaue)) {
          setError('شماره موبایل خود را کامل وارد کنید');
          setColorerror('red');
        } else {
          setError('شماره موبایل فقط به عدد و انگلیسی قابل ثبت است');
          setColorerror('red');
        }
      }
    } else {
      setError('');
      setColorerror('');
      handelValue(name, '');
    }
  };
  const checkeMobilenumber = async (number) => {
    try {
      const res = await Axios.get(
        `${urldashboard}/userManagement/checkexist/${number}`,
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        }
      );
      const data = await res.data.data;
      setStatuseMobile(data.isAvailable);
      handelstatusemobile(data.isAvailable);
      setUserIDFind(data.userId);
      if (data.isAvailable === true && !isSmsLog) {
        setColorerror('red');
        toast.error(' شماره موبایل وارد شده قبلا ثبت شده', {
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      const serverData = error?.response?.data?.data;
      if (serverData) {
        setStatuseMobile(serverData?.isAvailable);
        handelstatusemobile(serverData?.isAvailable);
        setUserIDFind(serverData?.userId);

        if (serverData?.isAvailable === true && !isSmsLog) {
          setColorerror('red');
          toast.error(' شماره موبایل وارد شده قبلا ثبت شده', {
            position: 'bottom-left',
            autoClose: 5000,
          });
        }
      } else {
        console.log('Unknown error:', error);
      }
    }
  };

  return (
    <Form.Group>
      {label ? <Form.Label>{label}</Form.Label> : null}
      <FormControl
        type='text'
        placeholder={Placeholder ? Placeholder : ''}
        name={name ? name : ''}
        autoComplete={autoComplete ? 'off' : null}
        defaultValue={defaultValue ? defaultValue : ''}
        dir='ltr'
        disabled={disabled}
        required
        onChange={hedelonCheng}
        maxLength='11'
      />
      {statuseMobile && !isSmsLog ? (
        ismodal && (
          <Form.Text
            onClick={() => handelmobileNumber(userIDFind)}
            style={{ color: colorerror, cursor: 'pointer' }}
          >
            شماره قبلا ثبت شده (ادامه سفارش)
          </Form.Text>
        )
      ) : error ? (
        <Form.Text className='mr-2' style={{ color: colorerror }}>
          {error}
        </Form.Text>
      ) : null}
    </Form.Group>
  );
}

Mobilecheckexist.propTypes = {
  /** تابع ارسال داده به کامپوننت بالا سری است */
  handelValue: PropTypes.func,
};
